angular.module('impactx.approval').controller('ApprovalGroupCtrl', [
    '$scope',
    'ApprovalStatus',
    ApprovalGroupController]);

function ApprovalGroupController($scope, ApprovalStatus) {
    var inactive = [1, 7, 8];
    $scope.getStatusColor = function(entry) {
        return ApprovalStatus.getStatusColor(entry.status, false);
    };

    $scope.getBorderStyle = function (index) {
        var status = $scope.group.setEntries[index].status;
        var borderStyle = "approval-group-entry";
        if (inactive.indexOf(status) === -1) {
            borderStyle = borderStyle + "-action";
        }
        if (index === 0) {
            return borderStyle + "-first"
        }
        else if (index === $scope.group.setEntries.length - 1) {
            return borderStyle + "-last"
        }
        return borderStyle + "-middle";
    };

    $scope.getSpacerStyle = function () {
        var clazz = "approval-group";
        if ($scope.onlyOneEntry) {
            return clazz + "-single";
        }
        else {
            if ($scope.isFirstEntry) {
                return clazz + '-first';
            }
            else if ($scope.isLastEntry) {
                return clazz + '-last';
            }
            else {
                return clazz;
            }
        }
    };
}